import React from 'react'
import './scheduling-modal-content.scss'

export default ({ ContentToShow }) => ContentToShow ? (<ContentToShow />) : (<div />)
